export const contentContainer = ({ isMobile }) => ({
  width: isMobile ? "100%" : "80%",
  minWidth: isMobile ? "auto" : "650px",
  maxWidth: isMobile ? "350px" : "auto",
  margin: "0 auto",
  padding: isMobile ? "30px 30px 10px 30px" : "0",
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
});

export const contentItemContainer = ({ isMobile }) => ({
  width: "100%",
  height: "100%",
  padding: isMobile ? "0" : "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const videoContainer = {
  width: "100%",
  display: "table",
  border: "1px solid #808080",
  borderRadius: "10px",
  overflow: "hidden",
};

export const videoControlsContainer = {
  position: "relative",

  ":hover > #modal-compare-video-play-button": {
    display: "block",
  },
};

export const videoPlayButton = {
  position: "absolute",
  bottom: "0",
  right: "7px",
  transform: "translate(-5%, -5%)",
  cursor: "pointer",
};

export const videoPauseButton = {
  position: "absolute",
  bottom: "0",
  right: "7px",
  transform: "translate(-5%, -5%)",
  cursor: "pointer",
  display: "none",
};

export const emptyVideoBox = ({ isTablet }) => ({
  width: "100%",
  padding: "21%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  fontStyle: "normal",
  fontWeight: "200",
  fontSize: isTablet ? "20px" : "30px",
  lineHeight: "30px",
  textAlign: "center",
  letterSpacing: "0.025em",
  textTransform: "uppercase",
  color: "#808080",

  "::after": {
    content: "''",
    display: "block",
    paddingBottom: "100%",
  },
});

export const emptyVideoBoxContent = {
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  left: "50%",
  width: "55%",
};

export const downArrow = {
  width: "24px",
  height: "24px",
  position: "absolute",
  bottom: "8%",
};

export const dropdownContainer = ({ isMobile }) => ({
  width: "100%",
  padding: isMobile ? "20px 0" : "30px 0 20px 0",
  textTransform: "uppercase",
  textAlign: "left",
});

export const dropdownLabel = ({ isMobile }) => ({
  fontSize: "20px",
  fontWeight: "300",
  lineHeight: "20px",
  letterSpacing: "0.05em",
  display: isMobile ? "none" : "block",
  marginBottom: "10px",
});

export const compareInfoContainer = ({ isMobile }) => ({
  width: "100%",
  marginRight: "auto",
  paddingTop: "10px",
  flexDirection: "column",
  display: isMobile ? "none" : "flex",
  borderTop: "solid 4px #E6E6E6",
  fontSize: "20px",
  fontWeight: "200",
});

export const modalContentRow = {
  padding: "10px 0",
  borderBottom: "1px solid #E6E6E6",
};

export const modalContentText = {
  fontWeight: "400",
};
